import React from 'react';
import { PlayButtonWrapper as CompiledPlayButtonWrapper } from './playButtonWrapper-compiled';

export const PlayButtonWrapper = (props: any) => <CompiledPlayButtonWrapper {...props} />;
